import axios from 'axios';
import { default401 } from './auth';
import { store } from '../store';

export const getPermissions = (agent, level) => {
  const state = store.getState();
  const { token } = state.auth;

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/${level}/`,
    headers: { Authorization: `Token ${token}` },
    params: { agent },
  }).then(({ data }) => {
    store.dispatch({ type: 'LOAD_PERMISSIONS', level, records: data });
  }).catch(default401);
};

export const createPermission = (agent, type, details) => {
  const state = store.getState();
  const { token } = state.auth;

  // Convert to API-friendly values.
  const data = { ...details };
  if ('active' in data) {
    data.active = data.active ? 'True' : 'False';
  }
  if ('middle_name' in data) {
    data.middle_name = data.middle_name || '';
  }

  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/${type}/`,
    headers: { Authorization: `Token ${token}` },
    data,
    params: { agent },
  }).catch(default401);
};

export const updatePermission = (id, type, details) => {
  const state = store.getState();
  const { token } = state.auth;

  // Convert to API-friendly values.
  const data = { ...details };
  data.active = data.active === 'Active' ? 'True' : data.active;
  data.active = data.active === 'Inactive' ? 'False' : data.active;
  data.middle_name = data.middle_name || '';

  return axios({
    method: 'put',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/${type}/${id}/`,
    headers: { Authorization: `Token ${token}` },
    data,
  }).catch(default401);
};

export const deletePermission = (id, type) => {
  const { token } = store.getState().auth;

  return axios({
    method: 'put',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/${type}/${id}/`,
    headers: { Authorization: `Token ${token}` },
  }).catch(default401);
};
